import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';

// Previously ChecklistItemTranslated
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FeatureDisplayChecklistItem = ({
  tooltipMessage,
  message,
  secondaryMessage,
  isAvailable = true
}) => {
  const hasTooltip = !!tooltipMessage;
  const color = isAvailable ? 'text-core-default' : 'icon-core-subtle';
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "right",
    title: tooltipMessage,
    children: /*#__PURE__*/_jsx(View, {
      cursor: hasTooltip ? 'help' : undefined,
      children: /*#__PURE__*/_jsxs(Flex, {
        children: [/*#__PURE__*/_jsx(View, {
          marginInlineEnd: "300",
          children: isAvailable ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(SuccessIcon, {
              color: color
            }), /*#__PURE__*/_jsx(ScreenReaderOnly, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-pages-ui.merchCardsV2.priorityFeatures.screenReader.featureAvailable"
              })
            })]
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(RemoveIcon, {
              color: color
            }), /*#__PURE__*/_jsx(ScreenReaderOnly, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-pages-ui.merchCardsV2.priorityFeatures.screenReader.featureUnavailable"
              })
            })]
          })
        }), /*#__PURE__*/_jsxs(Text, {
          as: "span",
          color: color,
          children: [message, secondaryMessage ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [" ", secondaryMessage]
          }) : null]
        })]
      })
    })
  });
};